/** Canonical in-app path for the MasterChart product surface. */
export const MASTERCHART_DASHBOARD_PATH = '/dashboard/masterchart';

/** Old path, kept only so legacy links and bookmarks redirect. */
export const MASTERCHART_LEGACY_PATH = '/dashboard/health-records';

export function masterChartPath(subPath = '') {
  if (!subPath) return MASTERCHART_DASHBOARD_PATH;
  return `${MASTERCHART_DASHBOARD_PATH}/${String(subPath).replace(/^\//, '')}`;
}

export const MASTERCHART_DRAWER_MATCH_PATHS = [
  MASTERCHART_DASHBOARD_PATH,
  MASTERCHART_LEGACY_PATH,
  '/dashboard/medications',
];

/** Build redirect target when leaving a legacy /health-records URL. */
export function masterChartLegacyRedirectTarget(pathname = '', search = '') {
  const legacy = MASTERCHART_LEGACY_PATH;
  const remainder =
    pathname === legacy || pathname.startsWith(`${legacy}/`)
      ? pathname.slice(legacy.length)
      : '';
  return `${MASTERCHART_DASHBOARD_PATH}${remainder}${search}`;
}
